import { IGradebookReducer } from '../Interfaces/IGradebookReducer';
import { gradebookInitState } from './InitState';
import { studentExercisesResultReducer } from './StudentExercisesResult';
import { IAction } from '../../../../../__core/Interfaces/IAction';
import { StudentExercisesResultResponse } from '../Types/StudentExercisesResultResponse';
import { studentExerciseFetchInProgressReducer } from './StudentExerciseFetchInProgress';
import { IEvent } from '../../../../../__core/Interfaces/IEvent';
import { setPointsForCriteriaInProgressReducer } from './SetPointsForCriteriaInProgress';
import { setPointsForExerciseInProgressReducer } from './SetPointsForExerciseInProgress';
import { criteriaGroupsReducer } from '../../../Reducers/CriteriaGroups';
import { CriteriaGroupResponse } from '../Types/CriteriaGroupResponse';
import { ISetPointsForCriteriaInProgress } from '../Interfaces/ISetPointsForCriteriaInProgress';
import { ISetPointsForExerciseInProgress } from '../Interfaces/ISetPointsForExerciseInProgress';
import { setPublicationsInProgressReducer } from './SetPublicationsInProgress';
import { setMaxMinPointsForStudentInProgress } from './SetMaxMinPointsForStudentInProgress';

export type GradebookReducerAction =
  | IAction<StudentExercisesResultResponse>
  | IAction<string>
  | IEvent;

export const gradebookReducer = (
  state: IGradebookReducer = gradebookInitState,
  action: GradebookReducerAction
): IGradebookReducer => ({
  studentExercisesResult: studentExercisesResultReducer(
    state.studentExercisesResult,
    action as IAction<StudentExercisesResultResponse>
  ),
  studentExerciseFetchInProgress: studentExerciseFetchInProgressReducer(
    state.studentExerciseFetchInProgress,
    action as IEvent
  ),
  setPointsForCriteriaInProgressId: setPointsForCriteriaInProgressReducer(
    state.setPointsForCriteriaInProgressId,
    action as IAction<ISetPointsForCriteriaInProgress>
  ),
  setPointsForExerciseInProgressId: setPointsForExerciseInProgressReducer(
    state.setPointsForExerciseInProgressId,
    action as IAction<ISetPointsForExerciseInProgress>
  ),
  criteriaGroups: criteriaGroupsReducer(
    state.criteriaGroups,
    action as IAction<CriteriaGroupResponse>
  ),
  setPublicationsInProgressId: setPublicationsInProgressReducer(
    state.setPublicationsInProgressId,
    action as IAction<string>
  ),
  setPointsForStudentInProgressId: setMaxMinPointsForStudentInProgress(
    state.setPointsForStudentInProgressId,
    action as IAction<string>
  ),
});
